import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';
import JsBarcode from 'jsbarcode';

import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'

import ImprDC from '../../../components/funcionales/imprdc'

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import ListaZo from '../../../components/funcionales/dirmayor/listazo';
import ListaBa from '../../../components/funcionales/dirmayor/listaba';
import selDirmayor from '../../../functions/seldirmayor';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

// "use strict";
//dropdown ESTADOS
const DetalleNivelEst1 = props => {
  return (
    <option style={props.styles.input} value={props.elemento.estadoCli}>{props.elemento.estadoCli}</option>
  )
};

const ListaEst = ({styles, handleChange, list, argsDocum}) => {
  const Nivel1Detalle = list.map((elemento, i) => <DetalleNivelEst1 styles={styles} elemento={elemento} key={i} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="estadoCli" id="miLista6" value={argsDocum.estadoCli} onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown ESTADOS

//dropdown CICLOS FACTURACION
const DetalleCF1 = props => {
  return (
    <option dato1={props.elemento._id} value={props.elemento.cicloFact} style={props.styles.input}>{props.elemento.cicloFact}</option>
  )
};

const ListaCF = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleCF1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="cicloFact" id="miListaCF" onChange={(ev)=>handleChange(ev)}>
        <option value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CICLOS DE FACTURACION

//dropdown PROCESOS DE FACT
const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.observaciones} dato2={props.elemento.codProcFact}
        value={props.elemento._id} style={props.styles.input}>{props.elemento.descrDpto} ={'>'} {props.elemento.nombreCiudad} ={'>'} {props.elemento.descrClaseServ} ={'>'} RANGO: {props.elemento.factInicial} - {props.elemento.factFinal} ={'>'} CICLO: {props.elemento.cicloFact}</option>
  )
};

const Lista = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="proceso" id="miListaP"  onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown PROCESOS DE FACT

//Lista de facturas
const FactCli = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.estadoCliente}</td>
      <td className=''>{elemento.nombreCliente}</td>
      <td className=''>{elemento.apellidoCliente}</td>
      <td className=''>{elemento.nombreBarrio}</td>
      <td className='right aligned'>{elemento.saldoPendiente}</td>
    </tr>
  )
};

const ListaFact = ({list}) => {
  const nivel1Detalle = list.map((elemento, _id) => <FactCli elemento={elemento} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// const fechaHoy = new Date()
// let agnoHoy = fechaHoy.getFullYear()
// let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
// let fechaHoy = new Date()
// // let fechaIni = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-01'
// fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

class FactIDC2 extends React.Component {
  state={argsDocum: {fechaAntesUltDX: "", mes: "", desdeF: this.props.fechaIni, hastaF: "", numVecesDX: 0, estadoCli: "Todos...", cicloFact: "Todos..."}, totFras: 0, listFact: [],
        printFras: "uno", stImpr: false, clientesFra: [], argsSelDpto: this.props.argsSelDpto,
        observaciones: "", permiteUpdate: true, confirmaAct: false, open: false, errors: []}

  handleChange = (ev) => {
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    // console.log(ev.target.checked)
    if(ev.target.name==="imprimir"){
      if(ev.target.checked===true){
        this.setState({printFras: ev.target.value})
      }
    }else{
      if(ev.target.name==="proceso"){
        let miLista = document.getElementById("miListaP");
        this.setState({observaciones: miLista.options[miLista.selectedIndex].attributes[0].value})
      }else{
        const argsDocum = this.state.argsDocum
        if(ev.target.name==="estadoCli"){
          let miLista = document.getElementById("miLista6");
          argsDocum[ev.target.name] = miLista.options[miLista.selectedIndex].text
        }else{
          if(ev.target.name==="cicloFact"){
            let miLista = document.getElementById("miListaCF");
            argsDocum[ev.target.name] = miLista.options[miLista.selectedIndex].text
          }else{
            argsDocum[ev.target.name] = ev.target.value
          }
        }
        let listFact = []
        this.setState({argsDocum, listFact})
        // console.log(argsDocum)
      }
    }
    this.setState({stImpr: false})
  }

  handleSubmit = async (ev, argsDocum)=>{
    let archPdf = ev.target.name
    // console.log(this.props.list)
    // console.log(this.props.list2)
    // console.log(this.props.allFacturacion.allFacturacion)
    document.body.style.cursor = 'wait'
    if(!this.props.list||!this.props.list2||!this.props.allFacturacion.allFacturacion){
      archPdf = "nohaydatos"
      // console.log("cargando...")
      errors.push({path: "cargando", message: "Proceso de cargue de la información, por favor espere un momento..."});
      // alert("Proceso de cargue de la información, por favor espere un momento...")
    }
    let errors = []
    if(!argsDocum.desdeF){
      errors.push({path: "Desde", message: "Debe seleccionar la fecha inicial de procesos de facturación"});
    }
    if(!argsDocum.hastaF){
      errors.push({path: "Hasta", message: "Debe seleccionar la fecha final de procesos de facturación"});
    }
    if(!argsDocum.fechaAntesUltDX&&argsDocum.estadoCli!=="Todos..."&&argsDocum.estadoCli!=="ACTIVO"){
      errors.push({path: "Hasta", message: "Debe seleccionar la fecha última DX"});
    }

    this.setState({errors})
    if(errors.length===0){
      let nombreArch = "doccobro.csv"
    let clientesFra = []

    let listFact = []
    // let listFactTemp = []
    if(archPdf!=="nohaydatos"&&archPdf!=="pdf"){
      let miLista = document.getElementById("miListaP");
      // let proceso = miLista.options[miLista.selectedIndex].attributes[1].value

      // const argsBuscarFact = {fechaMov: { $gte: argsDocum.desdeF, $lte: argsDocum.hastaF }, tipoGen: "proceso"}
      // if(miLista.options[miLista.selectedIndex].text!=="Todos..."){
      //   argsBuscarFact.codProcFact = miLista.options[miLista.selectedIndex].attributes[1].value
      // }else{
      //   argsBuscarFact.codProcFact = null
      // }
      // console.log(argsBuscarFact)
      // if(this.props.allFacturacion.allFacturacion){
      //   console.time(1)
      //   let {data} = await this.props.allFacturacion.refetch(argsBuscarFact)
      //   console.timeEnd(1)
      //   // console.log(this.props.allFacturacion.allFacturacion)
      //   listFactTemp = await data.allFacturacion
      //   // console.log(listFactTemp)
      // }

      // let argsBuscarCL = {}
      // argsBuscarCL.descrDpto=null
      // argsBuscarCL.nombreCiudad=null
      // argsBuscarCL.nombreZona=null
      // argsBuscarCL.nombreBarrio=null
      // if(!argsBuscarCL.contrato){
      //   argsBuscarCL.contrato=null
      // }
  
      // //filtrar por dpto, ciudad, zona, barrio
      // if(!this.state.argsSelDpto.descrDpto||this.state.argsSelDpto.descrDpto==="Todos..."){
      //   // listFactTemp = listFactTemp
      // }else{
      //   if(!this.state.argsSelDpto.nombreCiudad||this.state.argsSelDpto.nombreCiudad==="Todas..."){
      //     argsBuscarCL.descrDpto=this.state.argsSelDpto.descrDpto

      //     listFactTemp = listFactTemp.filter(elemento => 
      //       elemento.descrDpto===this.state.argsSelDpto.descrDpto)
      //   }else{
      //     nombreArch = "d" + this.state.argsSelDpto.codigoCiudadInterno + this.props.empresa.prefijoServ + ".csv"
      //     if(!this.state.argsSelDpto.nombreZona||this.state.argsSelDpto.nombreZona==="Todas..."){
      //       argsBuscarCL.descrDpto=this.state.argsSelDpto.descrDpto
      //       argsBuscarCL.nombreCiudad=this.state.argsSelDpto.nombreCiudad

      //       listFactTemp = listFactTemp.filter(elemento => 
      //         elemento.descrDpto===this.state.argsSelDpto.descrDpto&&
      //         elemento.nombreCiudad===this.state.argsSelDpto.nombreCiudad)
      //     }else{
      //       if(!this.state.argsSelDpto.nombreBarrio||this.state.argsSelDpto.nombreBarrio==="Todos..."){
      //         argsBuscarCL.descrDpto=this.state.argsSelDpto.descrDpto
      //         argsBuscarCL.nombreCiudad=this.state.argsSelDpto.nombreCiudad
      //         argsBuscarCL.nombreZona=this.state.argsSelDpto.nombreZona

      //         listFactTemp = listFactTemp.filter(elemento =>
      //           elemento.descrDpto===this.state.argsSelDpto.descrDpto&&
      //           elemento.nombreCiudad===this.state.argsSelDpto.nombreCiudad&&
      //           elemento.nombreZona===this.state.argsSelDpto.nombreZona)
      //       }else{
      //         argsBuscarCL.descrDpto=this.state.argsSelDpto.descrDpto
      //         argsBuscarCL.nombreCiudad=this.state.argsSelDpto.nombreCiudad
      //         argsBuscarCL.nombreZona=this.state.argsSelDpto.nombreZona
      //         argsBuscarCL.nombreBarrio=this.state.argsSelDpto.nombreBarrio

      //         listFactTemp = listFactTemp.filter(elemento =>
      //           elemento.descrDpto===this.state.argsSelDpto.descrDpto&&
      //           elemento.nombreCiudad===this.state.argsSelDpto.nombreCiudad&&
      //           elemento.nombreZona===this.state.argsSelDpto.nombreZona&&
      //           elemento.nombreBarrio===this.state.argsSelDpto.nombreBarrio)
      //       }
      //     }
      //   }
      // }
      // console.log(this.state.argsSelDpto)
      // console.log(argsBuscarCL)
      // if(this.props.allCliBasico.allCliBasico){
      //   console.time(2)
      //   let {data} = await this.props.allCliBasico.refetch(argsBuscarCL)
      //   console.timeEnd(2)
      //   clientesFra = await data.allCliBasico
      // }
      

      let argsBuscarCL = ""
      if(this.state.argsSelDpto.descrDpto===undefined||this.state.argsSelDpto.descrDpto==="Todos..."){

      }else{
        if(this.state.argsSelDpto.nombreCiudad===undefined||this.state.argsSelDpto.nombreCiudad==="Todas..."){
          if(argsBuscarCL){argsBuscarCL += `, `}
          argsBuscarCL += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
        }else{
          if(this.state.argsSelDpto.nombreZona===undefined||this.state.argsSelDpto.nombreZona==="Todas..."){
            if(argsBuscarCL){argsBuscarCL += `, `}
            argsBuscarCL += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
            argsBuscarCL += `, 'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
          }else{
            if(this.state.argsSelDpto.nombreBarrio===undefined||this.state.argsSelDpto.nombreBarrio==="Todos..."){
              if(argsBuscarCL){argsBuscarCL += `, `}
              argsBuscarCL += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
              argsBuscarCL += `, 'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
              argsBuscarCL += `, 'dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}'`
            }else{
              if(argsBuscarCL){argsBuscarCL += `, `}
              argsBuscarCL += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
              argsBuscarCL += `, 'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
              argsBuscarCL += `, 'dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}'`
              argsBuscarCL += `, 'dirmayor.ciudades.zonas.barrios.nombreBarrio': '${this.state.argsSelDpto.nombreBarrio}'`
            }
          }
        }
      }

      if(this.props.allClientesRtes.allClientesRtes){
        let condic1 = "{$match: {"
        if(argsBuscarCL){
          condic1 += argsBuscarCL + ", "
        }
        // if(this.state.argsDocum.estadoCli!=="Todos..."&&this.state.argsDocum.estadoCli!=="ACTIVO"){
        //   condic1 += `fechaUltDX: {$lte: '${this.state.argsDocum.fechaAntesUltDX}'}, `
        //   // clientesFra = clientesFra.filter(cliente => cliente.fechaUltDX<=this.state.argsDocum.fechaAntesUltDX)
        // }
        if(this.state.argsDocum.estadoCli!=="Todos..."&&this.state.argsDocum.estadoCli!=="DESCONECTADO, SUSPENDIDO o RETIRADO"){
          if(this.state.argsDocum.cicloFact==="Todos..."){
            condic1 += `estadoCliente: {$in: ['${this.state.argsDocum.estadoCli}']}`
            // clientesFra = clientesFra.filter(cliente => cliente.estadoCliente===this.state.argsDocum.estadoCli)
          }else{
            condic1 += `estadoCliente: {$in: ['${this.state.argsDocum.estadoCli}']}, cicloFact: '${this.state.argsDocum.cicloFact}'`
            // clientesFra = clientesFra.filter(cliente => cliente.estadoCliente===this.state.argsDocum.estadoCli&&
            //   cliente.cicloFact===this.state.argsDocum.cicloFact)
          }
        }else{
          if(this.state.argsDocum.estadoCli==="DESCONECTADO, SUSPENDIDO o RETIRADO"){
            if(this.state.argsDocum.cicloFact==="Todos..."){
              condic1 += `estadoCliente: {$in: ['DESCONECTADO', 'SUSPENDIDO', 'RETIRADO']}`
              // clientesFra = clientesFra.filter(cliente => cliente.estadoCliente==="DESCONECTADO"||
              //   cliente.estadoCliente==="SUSPENDIDO"||cliente.estadoCliente==="RETIRADO")
            }else{
              condic1 += `estadoCliente: {$in: ['DESCONECTADO', 'SUSPENDIDO', 'RETIRADO']}, cicloFact: '${this.state.argsDocum.cicloFact}'`
              // clientesFra = clientesFra.filter(cliente => (cliente.estadoCliente==="DESCONECTADO"||
              //   cliente.estadoCliente==="SUSPENDIDO"||cliente.estadoCliente==="RETIRADO")&&
              //   cliente.cicloFact===this.state.argsDocum.cicloFact)
            }
          }else{
            if((this.state.argsDocum.cicloFact!=="Todos..."&&this.state.argsDocum.cicloFact!=="")){
              condic1 += `cicloFact: '${this.state.argsDocum.cicloFact}'`
              // clientesFra = clientesFra.filter(cliente => cliente.cicloFact===this.state.argsDocum.cicloFact)
            }
          }
        }
        if(condic1!=="{$match: {"){
          condic1 += "}}, "
        }else{
          condic1 = ""
        }
        // console.log(condic1)

        let condic2 = ""
        if(miLista.options[miLista.selectedIndex].text!=="Todos..."){
          condic2 += `, codProcFact: '${miLista.options[miLista.selectedIndex].attributes[1].value}'`
          // argsBuscarFact.codProcFact = miLista.options[miLista.selectedIndex].attributes[1].value
        }else{
          condic2 += `, codProcFact: {$ne: 'ANULADA'}`
        }

        console.time(2)
        argsBuscarCL = {tipoqry: `[
          ${condic1}
          {$lookup: {
                from: "facturacions", let: {contrato: "$contrato"},
                pipeline: [
                    {$match: {fechaMov: { $gte: '${argsDocum.desdeF}', $lte: '${argsDocum.hastaF}' },
                          tipoGen: "proceso"${condic2}}},
                    {$match: {$expr: {$eq: ["$contrato",  "$$contrato"]}}},
                ],
                as: "fact"
              }},
          {$match: {fact: {$size:0}}},
        ]`}
        // console.log(argsBuscarCL)
        let {data} = await this.props.allClientesRtes.refetch(argsBuscarCL)
        console.timeEnd(2)
        clientesFra = await data.allClientesRtes

        // Lo siguiente porque no funcionó poniendo la condición en el aggregate
        if(this.state.argsDocum.estadoCli!=="Todos..."&&this.state.argsDocum.estadoCli!=="ACTIVO"){
          clientesFra = clientesFra.filter(cliente => cliente.fechaUltDX>=this.state.argsDocum.fechaAntesUltDX)
        }

        // console.log(clientesFra)
      }
      
      
      // console.log(clientesFra)
      // console.log(this.state.argsDocum)

      // if(this.state.argsDocum.estadoCli!=="Todos..."&&this.state.argsDocum.estadoCli!=="ACTIVO"){
      //   clientesFra = clientesFra.filter(cliente => cliente.fechaUltDX<=this.state.argsDocum.fechaAntesUltDX)
      // }
      // if(this.state.argsDocum.estadoCli!=="Todos..."&&this.state.argsDocum.estadoCli!=="DESCONECTADO, SUSPENDIDO o RETIRADO"){
      //   if(this.state.argsDocum.cicloFact==="Todos..."){
      //     clientesFra = clientesFra.filter(cliente => cliente.estadoCliente===this.state.argsDocum.estadoCli)
      //   }else{
      //     clientesFra = clientesFra.filter(cliente => cliente.estadoCliente===this.state.argsDocum.estadoCli&&
      //       cliente.cicloFact===this.state.argsDocum.cicloFact)
      //   }
      // }else{
      //   if(this.state.argsDocum.estadoCli==="DESCONECTADO, SUSPENDIDO o RETIRADO"){
      //     if(this.state.argsDocum.cicloFact==="Todos..."){
      //       clientesFra = clientesFra.filter(cliente => cliente.estadoCliente==="DESCONECTADO"||
      //         cliente.estadoCliente==="SUSPENDIDO"||cliente.estadoCliente==="RETIRADO")
      //     }else{
      //       clientesFra = clientesFra.filter(cliente => (cliente.estadoCliente==="DESCONECTADO"||
      //         cliente.estadoCliente==="SUSPENDIDO"||cliente.estadoCliente==="RETIRADO")&&
      //         cliente.cicloFact===this.state.argsDocum.cicloFact)
      //     }
      //   }else{
      //     if((this.state.argsDocum.cicloFact!=="Todos..."&&this.state.argsDocum.cicloFact!=="")){
      //       clientesFra = clientesFra.filter(cliente => cliente.cicloFact===this.state.argsDocum.cicloFact)
      //     }
      //   }
      // }
      // console.log(clientesFra)

      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaFechaHoy} = await response.data.fecha
      let fechaHoy = fechaFechaHoy.substr(0,10)

      // console.log(listFactTemp)
      // console.log(this.props.allFacturacion.allFacturacion)
      // listFactTemp = listFactTemp.filter(factura => factura.codProcFact!=="ANULADA")
      // console.log("antes")
      console.time(3)

      if(parseInt(argsDocum.numVecesDX, 10)>0){
        // console.log("antes")
        // console.time(5)
        clientesFra = clientesFra.filter(cliente => cliente.saldoPendiente>0 && cliente.saldoPendiente>(parseInt(argsDocum.numVecesDX, 10) * cliente.cargoMensual) - 1)
        // console.timeEnd(5)
        // console.log("despues")
      }
      // console.log(clientesFra)
      clientesFra.forEach((elemento, ii) => {
        let saldoFiltro = 0
        if(parseInt(argsDocum.numVecesDX, 10)>0 && elemento.saldoPendiente>0){
          saldoFiltro = (parseInt(argsDocum.numVecesDX, 10) * elemento.cargoMensual) - 1
        }
        // console.log(ii, elemento.contrato, elemento.saldoPendiente, saldoFiltro, parseInt(argsDocum.numVecesDX, 10), elemento.cargoMensual)
        // if(elemento.saldoPendiente>0){
        if(elemento.saldoPendiente>saldoFiltro){
          let indexSearchC = -1
          // let indexSearchC = listFactTemp.findIndex( factura => factura.contrato===elemento.contrato )
          
          let indexSearchRec = -1
          if(this.props.empresa.empresaArchFE==="conectic"){
            indexSearchRec = this.props.listaRec.findIndex( docRecurso => docRecurso.numeroDocum===elemento.dirmayor.ciudades.zonas.barrios.numeroDocumR )
          }

          if(indexSearchC===-1){
            let linea1DNN = ""
            if(elemento.direccion.descrTipoVia1){
              linea1DNN = elemento.direccion.descrTipoVia1?elemento.direccion.descrTipoVia1:""
              linea1DNN += elemento.direccion.numeroTipoVia1?" " + elemento.direccion.numeroTipoVia1:""
              linea1DNN += elemento.direccion.descrTipoVia2?" " + elemento.direccion.descrTipoVia2:""
              linea1DNN += elemento.direccion.numeroTipoVia2?" " + elemento.direccion.numeroTipoVia2:""
              linea1DNN += elemento.direccion.numeroTipoVia2F?" " + elemento.direccion.numeroTipoVia2F:""
              linea1DNN += elemento.direccion.descrTipoUnd1?" " + elemento.direccion.descrTipoUnd1:""
              linea1DNN += elemento.direccion.numeroTipoUnd1?" " + elemento.direccion.numeroTipoUnd1:""
              linea1DNN += elemento.direccion.descrTipoUnd2?" " + elemento.direccion.descrTipoUnd2:""
              linea1DNN += elemento.direccion.numeroTipoUnd2?" " + elemento.direccion.numeroTipoUnd2:""
            }

            //PARA IMPRIMIR CODIGO DE BARRAS
            let factCodBarras = elemento.contrato
            factCodBarras = `000000000000000000000000${factCodBarras}`
            //slice => para extraer caracteres de la derecha
            factCodBarras = factCodBarras.slice(-10)

            let valorCodBarras = `00000000000000${elemento.saldoPendiente}`
            valorCodBarras = valorCodBarras.slice(-10)

            // let fechaCodBarras = `${fechaHoy.substr(0,4)}${fechaHoy.substr(5,2)}${fechaHoy.substr(8,2)}`
            // console.log(this.props.empresa, this.props.codBarrasRdo)

            factCodBarras =  `000000000000000000000000${elemento.contrato}`
            factCodBarras = factCodBarras.slice(-10)
            valorCodBarras = `00000000000000${elemento.saldoPendiente}`
            valorCodBarras = valorCodBarras.slice(-10)

            // let textoCB = `Ê415${this.props.codBarrasRdo}8020${factCodBarras}Ê3900${valorCodBarras}Ê96${fechaCodBarras}`
            // let textoCBTxt = `(415)${this.props.codBarrasRdo}(8020)${factCodBarras}(3900)${valorCodBarras}(96)${fechaCodBarras}`
            let codBarrasRdo = elemento.dirmayor.ciudades.codBarrasRdo?elemento.dirmayor.ciudades.codBarrasRdo:this.props.codBarrasRdo
            let textoCB = `Ê415${codBarrasRdo}8020${factCodBarras}Ê3900${valorCodBarras}`
            let textoCBTxt = `(415)${codBarrasRdo}(8020)${factCodBarras}(3900)${valorCodBarras}`
            // console.log(codBarrasRdo, textoCB, textoCBTxt)
            let canvas = document.createElement("canvas");
            // JsBarcode("#barcodecanvasjs", textoCB, {
            JsBarcode(canvas, textoCB, {
              format: "CODE128",
              ean128: true,
              text: textoCBTxt,
              lineColor: "#000000",
              width: 2,
              height: 50,
              // width: 2,
              // height: 50,
              displayValue: true
            });
            // let canvas = document.getElementById('barcodecanvasjs');
            let imgSource = canvas.toDataURL("image/png");
            //FIN PARA IMPRIMIR CODIGO DE BARRAS
            let argsUpd = {
              "_id": elemento._id,
              "contrato": elemento.contrato,
              "numeroDoc": elemento.numeroDoc,
              "estadoCliente": elemento.estadoCliente,
              "direccion": linea1DNN,
              "descrDpto": elemento.dirmayor.descrDpto,
              "nombreCiudad": elemento.dirmayor.ciudades.nombreCiudad,
              "codigoCiudadInterno": elemento.dirmayor.ciudades.codigoCiudadInterno,
              "nombreZona": elemento.dirmayor.ciudades.zonas.nombreZona,
              "nombreBarrio": elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio,
              "nombreCliente": elemento.nombreCliente,
              "apellidoCliente": elemento.apellidoCliente,
              "fechaMov": fechaHoy,
              "saldoPendiente": elemento.saldoPendiente,
              "numeroDocum": elemento.dirmayor.ciudades.zonas.barrios.numeroDocumR,
              "descrRecurso": elemento.dirmayor.ciudades.zonas.barrios.descrRecursoR,
              "codBarras": imgSource,
              "telContacto": indexSearchRec!==-1?this.props.listaRec[indexSearchRec].telContacto:"",
              "fechaUltDX": elemento.fechaUltDX?elemento.fechaUltDX:""
            };
            listFact.push(argsUpd)
          }
        }
      })
      console.timeEnd(3)
      // console.time(4)
      // listFact = _.orderBy(listFact, ['nombreBarrio', 'direccion'], ['asc', 'asc'])
      listFact = _.orderBy(listFact, ['descrRecurso', 'nombreCiudad', 'nombreBarrio', 'direccion'], ['asc', 'asc', 'asc', 'asc'])
      // console.log(listFact)
      // console.timeEnd(4)
      if(archPdf==="csv"){
        this.handleSubmitCsv(listFact, nombreArch)
      }

      this.setState({listFact, totFras: listFact.length, clientesFra})
      // this.setState({listFact, totFras: listFact.length})
    }
    // console.log(archPdf)
    if(archPdf==="pdf"&&this.state.listFact.length){
      // if(archPdf==="pdf"&&listFact.length){
      this.setState({stImpr: true})
      // this.setState({stImpr: true, clientesFra})
      }else{
        this.setState({stImpr: false})
      }
    }
    document.body.style.cursor = 'default'
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  handleSubmitCsv = async (listFact, nombreArch) => {
    // console.log(listFact)
    const response = await this.props.fecha({
      variables: {}
    });
    const {fechaFechaHoy} = await response.data.fecha
    let fechaImpr = fechaFechaHoy.substr(0,10)

    let txtString = ""
    txtString += 'fechaImpr;fechaFact;sucursal;numeroFra;contrato;fechaLimite;cedula;nombreCliente;apellidoCliente;'
    txtString += 'direccion;nombreBarrio;nombreCiudad;descripcionServicio;periodo;valorDetalleAntesDeIVA;valorDetalleIVA;totalDetalle;'
    txtString += 'saldoPendiente;totalFraAntesImptos;totalFraDespuesImptos;totalAPagar'
    if(this.props.empresa.empresaArchFE==="conectic"){
      txtString += ';Recauda;telContacto;FechaUltDX'
    }
    txtString += "\r\n";
    for(let i=0; i<listFact.length; i++){
      let fechaLimite = "PAGO INMEDIATO"
      // let sucursal = ""
      // if(listFact[i].nombreCiudad==="PASTO"){
      //   sucursal = "41"
      // }
      let sucursal = listFact[i].codigoCiudadInterno
      txtString += fechaImpr + ';;'
      txtString += sucursal + ';;'
      txtString += listFact[i].contrato + ';' + fechaLimite + ';'
      txtString += listFact[i].numeroDoc + ';'
      txtString += listFact[i].nombreCliente + ';' + listFact[i].apellidoCliente + ';'
      txtString += listFact[i].direccion + ';' + listFact[i].nombreBarrio + ';'
      txtString += listFact[i].nombreCiudad + ';'
      txtString += 'Saldo pendiente;;'
      txtString += listFact[i].saldoPendiente + ';0;'
      txtString += listFact[i].saldoPendiente + ';' + listFact[i].saldoPendiente + ';'
      txtString += listFact[i].saldoPendiente + ';' + listFact[i].saldoPendiente + ';'
      txtString += listFact[i].saldoPendiente
      if(this.props.empresa.empresaArchFE==="conectic"){
        let fechaUltDX = listFact[i].fechaUltDX.substr(0,10)
        txtString += ';' + listFact[i].descrRecurso + ';' + listFact[i].telContacto + ';' + fechaUltDX
      }
      txtString += "\r\n";
    }

    var blob = new Blob([txtString], {type: "text/plain;charset=utf-8"});
    saveAs(blob, nombreArch);
  }

  handleImprimirTablaXls = (ev) => {
    var tableToExcel = (function() {
      var tmpElemento = document.createElement('a')
//window.btoa => Encode a string in base-64
      var uri = 'data:application/vnd.ms-excel;base64,'
        , template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
                            xmlns:x="urn:schemas-microsoft-com:office:excel">
                        <head>
                          <!--[if gte mso 9]>
                            <xml><x:ExcelWorkbook>
                                  <x:ExcelWorksheets>
                                    <x:ExcelWorksheet>
                                      <x:Name>{worksheet}</x:Name>
                                      <x:WorksheetOptions><x:DisplayGridlines/>
                                      </x:WorksheetOptions>
                                    </x:ExcelWorksheet>
                                  </x:ExcelWorksheets>
                                </x:ExcelWorkbook>
                            </xml>
                          <![endif]-->
                        </head>
                        <body><table>{table}</table></body>
                      </html>`
        , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
      return function(table, hoja) {
        if (!table.nodeType) table = document.getElementById(table)
        var ctx = {worksheet: hoja || 'Worksheet', table: table.innerHTML}
        tmpElemento.href = uri + base64(format(template, ctx))
        tmpElemento.download = 'resumenfact.xls';
        tmpElemento.click();
      }
    })()

    tableToExcel('tablaFras', 'facturas')
  }

  handleImprimirTablaPdf = (ev, argsDocum) => {
    var doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
    doc.setFontSize(14);
    doc.setFontType("bold");
    let texto1 = this.props.empresa.empresaRazonSocial
    let texto2 = "RESUMEN DE DOCUMENTOS DE COBRO"
    let fechaHoy = new Date()
    fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    let texto3 = fechaHoy
    doc.text(texto1, 108, 20, 'center')
    doc.setFontSize(12);
    doc.text(texto2, 108, 30, 'center')
    doc.setFontSize(10);
    doc.text(texto3, 108, 40, 'center')

    var source = document.getElementById("tablaFras");
    doc.autoTable({startY: 55,
                    tableLineColor: "blue",
                    tableLineWidth: 0.1,
                    styles: {
                      // font: 'Calibri',
                      fontSize: 10,
                      lineColor: "black",
                      lineWidth: 0.1
                    },
                    headStyles: {
                      fillColor: "#bdc3c7",
                      textColor: "black",
                      fontSize: 12
                    },
                    bodyStyles: {
                      fillColor: "#E9E4F0",
                      textColor: "black"
                    },
                    alternateRowStyles: {
                      fillColor: "white",
                      textColor: "black"
                    },
                    html: source,
                    margin: {top: 10, left: 2, right: 2},})
    // let finalY = doc.previousAutoTable.finalY; //para traer posicion final de la tabla
    // doc.text("TOTAL", 50, finalY + 15);
    doc.autoPrint({variant: 'non-conform'});
    // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
    // => UTILIZAR
    const pdfBlob = doc.output('blob');
    const url = URL.createObjectURL(pdfBlob);
    window.open(url);
    // doc.save('resumenfact.pdf')
  }

  async UNSAFE_componentWillMount(){
    if(this.state.argsDocum.fechaAntesUltDX===""){
      const argsDocum = this.state.argsDocum
      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaFechaHoy} = await response.data.fecha

      let numdiasUltDX = 1000*60*60*24*30*this.props.empresa.mesesUltDXImpDC
      let fechaFinal = new Date(fechaFechaHoy.substr(0,10)).getTime();
      fechaFinal = new Date(fechaFinal - numdiasUltDX)
      fechaFinal = (fechaFinal.getFullYear()) + '-' + ((fechaFinal.getMonth()+1)<10?'0'+(fechaFinal.getMonth()+1):(fechaFinal.getMonth()+1)) + '-' + (fechaFinal.getUTCDate()<10?'0'+fechaFinal.getUTCDate():fechaFinal.getUTCDate())
      argsDocum['fechaAntesUltDX'] = fechaFinal

      this.setState(argsDocum)
    }

    if(this.state.argsDocum.hastaF===""){
      const argsDocum = this.state.argsDocum
      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaFechaHoy} = await response.data.fecha
      argsDocum['hastaF'] = fechaFechaHoy.substr(0,10)
      this.setState(argsDocum)
    }
  }

  async componentDidUpdate(prevProps, prevState){
    if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
      let miLista = document.getElementById("miLista1");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoZona!==undefined&&this.props.argsSelDpto.codigoZona!==""){
      let miLista = document.getElementById("miLista2");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoZona){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreZona'] = "Todas..."
        argsSelDpto['codigoZona'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoBarrio!==undefined&&this.props.argsSelDpto.codigoBarrio!==""){
      let miLista = document.getElementById("miLista3");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoBarrio){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreBarrio'] = "Todos..."
        argsSelDpto['codigoBarrio'] = ""
        argsSelDpto['codigoTipoDocT'] = ""
        argsSelDpto['numeroDocumT'] = ""
        argsSelDpto['descrRecursoT'] = ""
        argsSelDpto['codigoTipoDocR'] = ""
        argsSelDpto['numeroDocumR'] = ""
        argsSelDpto['descrRecursoR'] = ""
        this.setState({argsSelDpto})
      }
    }

    if(this.state.stImpr!==prevState.stImpr){
      // console.log("entro stImpr")

      this.setState({stImpr: false})
    }
  }

  render(){
    const {argsDocum, totFras, listFact, stImpr, clientesFra} = this.state;
    const a050501 = this.props.autorizacUA.findIndex( autorizac => autorizac === "050501" );
    const a050505 = this.props.autorizacUA.findIndex( autorizac => autorizac === "050505" );
    const a050510 = this.props.autorizacUA.findIndex( autorizac => autorizac === "050510" );

    // const fechaHoy = new Date()
    // let agnoHoy = fechaHoy.getFullYear()
    // let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
    // mesHoy = agnoHoy + "-" + mesHoy
    // let mesMsg = ""
    // argsDocum.mes?mesMsg=argsDocum.mes:mesMsg=mesHoy
    // // let imgIcon = "images/archivo_32.png"
    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        dpto.options.selectedIndex = 0
      }
    }

    let colecc = selDirmayor(this.props.list1, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu
    let listZon = colecc.listZon
    let listBar = colecc.listBar

    let procMes = []
    this.props.list2.forEach((elemento, i) => {
      if(elemento.fechaCreate.substr(0, 10)>=argsDocum.desdeF&&elemento.fechaCreate.substr(0, 10)<=argsDocum.hastaF){
        procMes.push(elemento)
      }
    })
    
    // let procMes = this.props.list2.filter(elemento => elemento.mes===mesMsg)

    let listFactCl = []
    let imprFactCl = true
    if(stImpr){
      listFact.forEach((elemento, i) => {
        let indexSearch = clientesFra.findIndex( cliente => cliente.contrato===elemento.contrato )
        if(indexSearch===-1){
          imprFactCl = false
        }
        listFactCl.push({listFact: listFact[i], clientesFra: clientesFra[indexSearch]})
      })
    }
// console.log(listFactCl)
// console.log(this.props.argsBuscar)
// console.log(this.props.args)
// console.log(argsDocum)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
            <i className="large plus yellow icon"></i>
            Imprimir documentos de cobro
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1">
              <div>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '90%'}}>
                      <h1 style={{color: '#2C7744'}}>Imprimir documentos de cobro a clientes no facturados</h1>
                      <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0em'}}>
                        Seleccionar los procesos de facturación en los que no se les facturó a clientes con saldo pendiente<br/>
                      </p>

                        {/* <input type="radio" name="imprimir" value="uno" defaultChecked="true"  onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1em', fontWeight: 'bold'}}>&nbsp;Un solo archivo&nbsp;&nbsp;&nbsp;</label>
                        <input type="radio" name="imprimir" value="varios" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1em', fontWeight: 'bold'}}>&nbsp;Un archivo por factura</label> */}
                    </div>
                    {/* <div className="column" style={{width: '40%'}}>
                      <p>
                        <span style={{background: '#7F7FD5', padding: '0.5em', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                          Seleccionar mes: &nbsp;&nbsp;
                          <span>
                            <input style={{color: '#302b63', fontSize: '2em', paddingright: '2.5em'}} type='month' defaultValue={mesHoy} name="mes" id="mes" onChange={this.handleChange}/>
                          </span>
                        </span>
                      </p>
                    </div> */}
                  </div>
                </div>
                <hr></hr>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Procesos fact desde
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="desdeF" id="desdeF" value={argsDocum.desdeF} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Hasta
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="hastaF" id="hastaF" value={argsDocum.hastaF} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Saldo mayor o igual a X meses
                      </p>
                      <Form.Field>
                        <input value={argsDocum.numVecesDX} type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="numVecesDX" id="numVecesDX" placeholder='' onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Procesos de facturación
                </p>
                <Form.Field>
                  <Lista styles={this.props.styles} list={procMes} handleChange={this.handleChange}/>
                </Form.Field>
                <hr></hr>

                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Departamento
                        </label>
                        <ListaDe list={this.props.list1} styles={this.props.styles}
                          handleLista={this.props.handleLista} codigoCiudadUA={this.props.codigoCiudadUA}
                          codigoDptoUA={this.props.codigoDptoUA}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Ciudad
                        </label>
                        <ListaCi list={listCiu} styles={this.props.styles}
                          handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                          codigoCiudadUA={this.props.codigoCiudadUA}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Zona
                        </label>
                        <ListaZo list={listZon} styles={this.props.styles} handleLista2={this.props.handleLista2} argsSelCiu={this.props.argsSelCiu}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Barrio
                        </label>
                        <ListaBa list={listBar} styles={this.props.styles} handleLista3={this.props.handleLista3} argsSelZon={this.props.argsSelZon}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>

                <div className="ui four column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Ciclo de facturación
                      </p>
                      <Form.Field>
                        <ListaCF styles={this.props.styles} list={this.props.listaCF} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Estado
                      </p>
                      <Form.Field>
                        <ListaEst styles={this.props.styles} list={this.props.list} argsDocum={argsDocum} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    {(argsDocum.estadoCli!=="Todos..."&&argsDocum.estadoCli!=="ACTIVO") &&                    
                      <div className="column" style={{width: '50%'}}>
                      </div>
                    }
                    {(argsDocum.estadoCli!=="Todos..."&&argsDocum.estadoCli!=="ACTIVO") &&
                      <div className="column" style={{width: '50%'}}>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Fecha última DX mayor o igual a
                        </p>
                        <Form.Field>
                          <input style={this.props.styles.input} type='date' name="fechaAntesUltDX" id="fechaAntesUltDX" value={argsDocum.fechaAntesUltDX} onChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                    }
                  </div>
                </div>
                <hr></hr>
                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Total DC:&nbsp;{totFras}&nbsp;&nbsp;&nbsp;
                  {a050501!==-1 &&
                    <button className="ui right labeled icon button" style={this.props.styles.styBtn} onClick={(ev)=>this.handleImprimirTablaXls(ev)}>
                      <i className='file excel outline icon'></i>
                      Excel
                    </button>
                    // <a className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTablaXls(ev)}><i className='file excel outline icon'></i>Excel</a>
                  }
                  &nbsp;&nbsp;
                  {a050505!==-1 &&
                    <button className="ui right labeled icon button" style={this.props.styles.styBtn} onClick={(ev)=>this.handleImprimirTablaPdf(ev, argsDocum)}>
                      <i className='file pdf outline icon'></i>
                      Pdf
                    </button>
                    // <a className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTablaPdf(ev, argsDocum)}><i className='file pdf outline icon'></i>Pdf</a>
                  }
                </p>
                {this.props.empresa.modeloFactura!=="3" &&
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum)} fluid>
                          VER RESUMEN EN PANTALLA
                        </Button>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        {a050510!==-1 &&
                          <Button name="pdf" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum)} fluid>
                            GENERAR DC EN PDF
                          </Button>
                        }

                        {(stImpr&&imprFactCl) &&
                          <ImprDC listFactCl={listFactCl} list2={this.props.list2} empresa={this.props.empresa}/>
                        }
                      </div>
                    </div>
                  </div>
                }
                {this.props.empresa.modeloFactura==="3" &&
                  <div className="ui three column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '33%'}}>
                        <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum)} fluid>
                          VER RESUMEN EN PANTALLA
                        </Button>
                      </div>
                      <div className="column" style={{width: '33%'}}>
                        <Button id="csv" name="csv" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum)} fluid>
                            ARCHIVO CSV
                        </Button>
                      </div>
                      <div className="column" style={{width: '34%'}}>
                        {a050510!==-1 &&
                          <Button name="pdf" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum)} fluid>
                            GENERAR DC EN PDF
                          </Button>
                        }

                        {(stImpr&&imprFactCl) &&
                          <ImprDC listFactCl={listFactCl} list2={this.props.list2} empresa={this.props.empresa}/>
                        }
                      </div>
                    </div>
                  </div>
                }
                <hr></hr>
                <table id="tablaFras" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className=''>Contrato</th>
                      <th className=''>Estado</th>
                      <th className=''>Nombre</th>
                      <th className=''>Apelldo</th>
                      <th className=''>Barrio</th>
                      <th className='right aligned'>$ Saldo pendiente</th>
                    </tr>
                  </thead>
                  <ListaFact list={listFact}/>
                </table>
              </div>
            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allServicios, {name:'allServicios', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allFacturacion, {name:'allFacturacion', options: (props) => {return {variables: {agno: "agnoHoy", mes: mesHoy}}}}),
  // graphql(queries.query.allFacturacion, {name:'allFacturacion', options: (props) => {return {variables: {agno: "2017", mes: "01"}}}}),
  graphql(queries.query.allFacturacion, {name:'allFacturacion', options: (props) => {return {variables: {fechaMov: "2019-04-08"}}}}),

  // graphql(queries.query.allCliBasico, {name:'allCliBasico', options: (props) => {return {variables: {contrato: "XYZ321"}}}}),
  graphql(queries.query.allClientesRtes, {name:'allClientesRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: "XXXYYYZZZ"}}]`}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(FactIDC2)
